<template>
  <div class="pins">
    <van-overlay :show="show">
      <div class="wrapper" @click.stop>
        <van-loading size="24px" vertical>加载中...</van-loading>
      </div>
    </van-overlay>
    <div class="di">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item
            class="yuhujf"
            v-for="list in imglist"
            :key="list.advId"
            @click="tiao(list.advUrl)"
          >
            <img :src="list.advImg" width="100%" />
          </van-swipe-item>
        </van-swipe>
      </div>
    <div class="xiangmu">
      <div v-for="item in list" :key="item.id" @click="tiaozhuan(item.id, item.classifyName)">
        <img :src="item.serverHttp+item.classifyIcon" />
        <div>{{item.classifyName}}</div>
      </div>
    </div>
    <div class="mag magtop">
      <div>
        <img class="xiaoimg" src="../../assets/img/r.png" width="15px" />
        <span class="heis">最新课程</span>
      </div>
    </div>
    <van-empty
      class="custom-image imgsffa"
      :image="img"
      v-if="courlist.length == 0"
      description="本周没有直播"
    />
    <div class="pin1 ditus bott" v-for="(list, index) in courlist" :key="index" @click="dianji(list.lessonId)">
      <van-row>
          <van-col span="24">
            <van-col span="24" class="heise">{{ list.lessonName }}</van-col>
            <van-col span="24">
              <van-col span="16">
              <span class="lanm biao-span" v-if="list.subjectName !== null">{{ list.subjectName }}</span>
              <span class="hongmu biao-span" v-if="list.classifyName">{{list.classifyName }}</span>
              </van-col>
              <van-col span="8">
            <van-col span="24" class="magtop" style="    text-align: right;">
              <span v-if="list.liveStatus == '1'" class="jinru"
                  >进入直播</span
                >
                <span v-if="list.liveStatus == '2'" class="wei">未开始</span>
                <span v-if="list.liveStatus == '3'" class="jieshu"
                  >直播结束</span
                >
                <span v-if="list.liveStatus == '4'" class="jinru"
                  >查看回放</span
                >
              <!-- <span class="daanniu">进入直播</span> -->
            </van-col>
          </van-col>
            </van-col>
          </van-col>
          <van-col span="24">
            <van-col span="15" class="spanhong">
              <span>{{ yue(list.beginTime) }}</span>
                <span>{{ getWeekDay(list.beginTime) }}</span>
                <span>{{ slice(list.beginTime, list.endTime) }}</span>
            </van-col>
            <!-- <van-col span="9" class="huisezi">
              {{
                  list.lessonViewnum > 10000
                    ? yuetu(list.lessonViewnum)
                    : list.lessonViewnum
                }}<img src="../../assets/img/kan.png" width="15px" style="vertical-align: text-bottom;margin-left: 3px;"/>
                 {{
                  list.lessonZannum > 10000
                    ? yuetu(list.lessonZannum)
                    : list.lessonZannum
                }}<img src="../../assets/img/zan.png" width="15px" style="vertical-align: text-bottom;margin-left: 3px;"/>
            </van-col> -->
          </van-col>
        </van-row>
    </div>
    <dibu class="dibu"></dibu>
  </div>
</template>

<script>
import {courseclassify,courselist,courseonlinelist,advlist} from "@/api/home";
import { Toast } from "vant";
import dibu from "@/components/index/di";
export default {
  data() {
    return {
      show: false,
      curPage:1,
      list:[],
      courlist:[],
      endDate:'',
      beginDate:'',
      arr:[],
      imglist: [],
      img: require("../../assets/img/kong.png"),
    };
  },
  watch: {},
  components: {dibu},
  methods: {
    courseclassify(){
      let that = this;
      that.show = true;
      courseclassify({
        classifyLevel: 1
      })
        .then((res) => {
          that.list=res.data.data
         that.show = false;
        })
        .catch(() => {
          that.show = false;
        });
    },
    courselist(){
      let that = this;
      that.show = true;
      let params = {
        curPage: this.curPage,
        pageSize: 10,
        courseState: 1,
        // courseTypeid: 2,
        groupId: 1,
        courseClassify: this.index,
        classifyLevel: 1,
        isHaveHour:1
      };
      courselist(params)
        .then((res) => {
         that.arr=res.data.data.dataList
         that.show = false;
        })
        .catch(() => {
          that.show = false;
        });
    },
    dianjis(s,d) {
      // this.$router.push({
      //   path: "/video",
      //   query: {
      //     id: s,
      //   },
      // });
      if(d==2){
        this.$router.push({
        path: "/indexvideo",
        query: {
          id: s,
        },
      });
      }else{
        this.$router.push({
        path: "/video",
        query: {
          id: s,
          t: Date.now()
        },
      });
      }
    },
    courseonlinelist() {
      let that = this;
      let params = {
          courseTypeid: 1,
          roomTypes: 3,
          courseState: 1,
          curPage: 1,
          pageSize: 100,
          endDate: this.endDate,
          beginDate: this.beginDate,
          groupId:1,
          isHaveHour:1
          // courseTypeid: 1,
          // roomTypes: 3,
          // courseState: 1,
          // courseClassify: 2,
          // curPage: 1,
          // pageSize: 10,
        };
      courseonlinelist(params)
        .then((res) => {
          for (var i = 0; i < res.data.data.dataList.length; i++) {
            that.courlist.push(res.data.data.dataList[i]);
          }
          console.log(that.courlist)
          // that.show = false;
        })
        .catch(() => {
          // that.show = false;
        });
    },
    formatDate(date) {
      var myyear = date.getFullYear();
      var mymonth = date.getMonth() + 1;
      var myweekday = date.getDate();

      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }
      return myyear + "-" + mymonth + "-" + myweekday;
    },
     yue(s) {
      return s.slice(5, 11);
    },
    yuetu(s) {
      s = s / 10000;
      s = s.toFixed(2);
      return s + "万";
    },
    getWeekDay(dateString) {
      dateString = dateString.slice(0, 10);
      var dateArray = dateString.split("-");
      var date = new Date(
        dateArray[0],
        parseInt(dateArray[1] - 1),
        dateArray[2]
      );
      return "周" + "日一二三四五六".charAt(date.getDay());
    },
    slice(s, d) {
      return s.slice(10, 16) + " -" + d.slice(10, 16);
    },
    dianji(s) {
      this.$router.push({
        path: "/video",
        query: {
          id: s,
          t: Date.now()
        },
      });
    },
    tiaozhuan(id, classifyName){
      if(classifyName === "名师工作室") {
        this.$router.push({
          path: "/studio",
          query: {
            id: id,
          },
        });
      } else {
        this.$router.push({
          path: "/course",
          query: {
            id: id,
          },
        });
      }
    },
    advlist() {
      let that = this;
      let params = {
        schoolId: 0,
        apCode: "300",
      };
      advlist(params)
        .then((res) => {
          that.imglist = res.data.data;
        })
        .catch(() => {});
    },
    tiao(s) {
      if(s){
        window.location.href = s;
      }
    },
  },
  mounted() {
    this.advlist()
    var now = new Date(); // 当前日期
    var nowDayOfWeek = now.getDay(); // 今天本周的第几天
    var nowDay = now.getDate(); // 当前日
    var nowMonth = now.getMonth(); // 当前月
    var nowYear = now.getYear(); // 当前年
    nowYear += nowYear < 2000 ? 1900 : 0;
    var day = nowDayOfWeek || 7;
    this.beginDate = this.formatDate(
      new Date(now.getFullYear(), nowMonth, nowDay + 1 - day)
    );
    this.endDate = this.formatDate(
      new Date(now.getFullYear(), nowMonth, nowDay + 7 - day)
    );
    this.beginDate = this.beginDate.replace(/\//i, "-");
    this.endDate = this.endDate.replace(/\//i, "-");
    this.courseclassify()
    this.courselist()
    this.courseonlinelist()
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue